import reduce from 'lodash/reduce';
import { getEnsuredNumericInput } from '../inputs';

export const LOCATION_MODES = {
  ZIP_CODE: 1,
  CITY: 2,
  STATE: 4,
  COUNTRY: 5,
};

export const DEFAULT_INPUTS = {
  input_location_mode: LOCATION_MODES.COUNTRY,
  input_location: '',
  input_location_country: 'US',
  input_income: 1,
  input_size: 0,
};

export const totalSavings = (state, savings) =>
  reduce(
    savings,
    (sum, actionSavings, actionKey) => (
      sum + (getEnsuredNumericInput(state, `input_takeaction_${actionKey}`) * actionSavings)
    ),
    0,
  );
